<template>
  <text-box :label="$t('components.HiddenSectionsReport.title')" icon="eye-off-outline">
    <template v-slot:info-dialog>
      {{ $t('components.HiddenSectionsReport.info') }}
    </template>
    <template v-slot:info>
      <v-chip v-if="sections.length > 0" x-small color="primary" outlined class="mr-2">{{ sections.length }}</v-chip>
    </template>
    <div v-if="sections.length === 0" class="text-center grey--text text--darken-1 py-8">
      {{ $t('components.HiddenSectionsReport.nothingHidden') }}
    </div>
    <v-simple-table v-else dense>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">{{ $t('components.HiddenSectionsReport.section') }}</th>
            <th class="text-left">{{ $t('components.HiddenSectionsReport.reason') }}</th>
            <th class="text-left">{{ $t('components.HiddenSectionsReport.condition') }}</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="group in groupedSections">
            <tr :key="`group_${group.name}`" class="group-row">
              <td colspan="3" class="font-weight-bold text-uppercase caption">{{ group.name }}</td>
            </tr>
            <tr v-for="(item, index) in group.items" :key="`${group.name}_${index}`">
              <td>{{ item.name }}</td>
              <td class="grey--text text--darken-1">{{ reasonText(item) }}</td>
              <td><code v-if="item.condition" class="condition">{{ item.condition }}</code></td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>
  </text-box>
</template>

<script>
import TextBox from '@/components/TextBox.vue'

export default {
  props: {
    // [{ group, name, reason, params, condition }]. `reason` is a code from the vocabulary in
    // this component's locale file; `params` fills its placeholders; `condition` is the raw
    // data path or expression that failed, printed verbatim.
    sections: {
      type: Array,
      required: false,
      default: function () {
        return []
      }
    }
  },
  computed: {
    // Rows grouped by their `group` label, keeping the order in which the groups first appear
    // so the table follows the order of the view itself.
    groupedSections () {
      const order = []
      const byGroup = {}
      this.sections.forEach(function (item) {
        const group = item.group || ''
        if (!(group in byGroup)) {
          byGroup[group] = []
          order.push(group)
        }
        byGroup[group].push(item)
      })
      return order.map(function (name) {
        return { name: name, items: byGroup[name] }
      })
    }
  },
  methods: {
    // Falls back to the raw code when a view emits a reason this locale does not know,
    // so a newer caller never renders an empty cell.
    reasonText (item) {
      const key = 'components.HiddenSectionsReport.reasons.' + item.reason
      const text = this.$t(key, item.params || {})
      return text === key ? item.reason : text
    }
  },
  components: {
    TextBox
  }
}
</script>

<style scoped>
.group-row td {
  background-color: rgba(0, 0, 0, 0.03);
  letter-spacing: 0.08em;
}
.condition {
  font-size: 11px;
  background-color: rgba(0, 0, 0, 0.05);
  box-shadow: none;
  padding: 2px 6px;
}
</style>
